import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import affiliateRoutes from './routes'
import Store from 'src/store/index'

const createHistory = process.env.SERVER
? createMemoryHistory
: process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes: [
    ...affiliateRoutes, 
    {
      path: '/:catchAll(.*)*',
      component: () => import('pages/Error404.vue')
  }],
  history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
});

Router.beforeEach((to, from, next) => {
  if(!Store.state.user && to.meta && to.meta.auth) {
    Store.commit('setReturnRoute', to);
    Router.push({ name: 'login' });
  }
  next();
})

export default Router;
